import { render } from "./moniteringPolicy.vue?vue&type=template&id=3d0d7cc8&scoped=true"
const script = {}

import "./moniteringPolicy.vue?vue&type=style&index=0&id=3d0d7cc8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0d7cc8"]])

export default __exports__